/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M14 12.5555C14 15.8148 10 15.8148 10 12.5555C10 10.4815 11.9999 9 11.9999 9C11.9999 9 14 10.4815 14 12.5555Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12M22 12C22 6.47715 17.5228 2 12 2M22 12H20M2 12C2 6.47715 6.47715 2 12 2M2 12H4M12 2V4M19.0004 5L18 6M19.0004 19L18 18M5 19L6.00037 18M5 5L6 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.9999 9C11.9999 9 10 10.4815 10 12.5555C10 15.8148 14 15.8148 14 12.5555C14 10.4815 11.9999 9 11.9999 9Z"
				fill="currentColor"
			/>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12M22 12C22 6.47715 17.5228 2 12 2M22 12H20M2 12C2 6.47715 6.47715 2 12 2M2 12H4M12 2V4M19.0004 5L18 6M19.0004 19L18 18M5 19L6.00037 18M5 5L6 6M11.9999 9C11.9999 9 10 10.4815 10 12.5555C10 15.8148 14 15.8148 14 12.5555C14 10.4815 11.9999 9 11.9999 9Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM12 3.25C12.4142 3.25 12.75 3.58579 12.75 4V5.3C12.75 5.71421 12.4142 6.05 12 6.05C11.5858 6.05 11.25 5.71421 11.25 5.3V4C11.25 3.58579 11.5858 3.25 12 3.25ZM6.12967 6.07642C6.41883 5.77985 6.89366 5.77384 7.19024 6.063L8.07913 6.92967C8.37571 7.21883 8.38172 7.69366 8.09255 7.99024C7.80339 8.28682 7.32856 8.29283 7.03198 8.00367L6.14309 7.137C5.84651 6.84784 5.8405 6.373 6.12967 6.07642ZM17.8703 6.07642C18.1595 6.373 18.1535 6.84784 17.8569 7.137L16.968 8.00367C16.6714 8.29283 16.1966 8.28682 15.9074 7.99024C15.6183 7.69366 15.6243 7.21883 15.9209 6.92967L16.8098 6.063C17.1063 5.77384 17.5812 5.77985 17.8703 6.07642ZM3.25 11.8C3.25 11.3858 3.58579 11.05 4 11.05H5.33333C5.74755 11.05 6.08333 11.3858 6.08333 11.8C6.08333 12.2142 5.74755 12.55 5.33333 12.55H4C3.58579 12.55 3.25 12.2142 3.25 11.8ZM17.9167 11.8C17.9167 11.3858 18.2525 11.05 18.6667 11.05L20 11.05C20.4142 11.05 20.75 11.3858 20.75 11.8C20.75 12.2142 20.4142 12.55 20 12.55L18.6667 12.55C18.2525 12.55 17.9167 12.2142 17.9167 11.8ZM8.09298 15.6099C8.38209 15.9065 8.37599 16.3813 8.07936 16.6704L7.19014 17.5371C6.89351 17.8262 6.41868 17.8201 6.12957 17.5235C5.84046 17.2268 5.84656 16.752 6.14319 16.4629L7.0324 15.5962C7.32903 15.3071 7.80387 15.3132 8.09298 15.6099ZM15.9074 15.6098C16.1966 15.3132 16.6714 15.3072 16.968 15.5963L17.8569 16.463C18.1535 16.7522 18.1595 17.227 17.8703 17.5236C17.5812 17.8202 17.1063 17.8262 16.8098 17.537L15.9209 16.6703C15.6243 16.3812 15.6183 15.9063 15.9074 15.6098ZM10 12.5556C10 15.8148 14 15.8148 14 12.5556C14 11.1148 13.0349 9.96 12.4455 9.38909C12.3241 9.27151 12.2634 9.21271 12.1514 9.17711C12.07 9.15122 11.9299 9.15122 11.8485 9.17712C11.7365 9.21272 11.6758 9.27152 11.5544 9.38911C10.965 9.96002 10 11.1148 10 12.5556Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12M22 12C22 7.89936 19.5318 4.3752 16 2.83209M22 12H20M2 12C2 6.47715 6.47715 2 12 2V4M2 12H4M19.0004 5L18 6M19.0004 19L18 18M5 19L6.00037 18M5 5L6 6M11.9999 9C11.9999 9 9.99994 10.4815 9.99994 12.5555C9.99994 15.8148 13.9999 15.8148 13.9999 12.5555C13.9999 10.4815 11.9999 9 11.9999 9Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12M22 12C22 6.47715 17.5228 2 12 2M22 12H20M2 12C2 6.47715 6.47715 2 12 2M2 12H4M12 2V4M19.0004 5L18 6M19.0004 19L18 18M5 19L6.00037 18M5 5L6 6M11.9999 9C11.9999 9 10 10.4815 10 12.5555C10 15.8148 14 15.8148 14 12.5555C14 10.4815 11.9999 9 11.9999 9Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.75 4C12.75 3.58579 12.4142 3.25 12 3.25C11.5858 3.25 11.25 3.58579 11.25 4V5.3C11.25 5.71421 11.5858 6.05 12 6.05C12.4142 6.05 12.75 5.71421 12.75 5.3V4ZM7.19024 6.063C6.89366 5.77384 6.41883 5.77985 6.12967 6.07642C5.8405 6.373 5.84651 6.84784 6.14309 7.137L7.03198 8.00367C7.32856 8.29283 7.80339 8.28682 8.09255 7.99024C8.38172 7.69366 8.37571 7.21883 8.07913 6.92967L7.19024 6.063ZM17.8569 7.137C18.1535 6.84784 18.1595 6.373 17.8703 6.07642C17.5812 5.77985 17.1063 5.77384 16.8098 6.063L15.9209 6.92967C15.6243 7.21883 15.6183 7.69366 15.9074 7.99024C16.1966 8.28682 16.6714 8.29283 16.968 8.00367L17.8569 7.137ZM4 11.05C3.58579 11.05 3.25 11.3858 3.25 11.8C3.25 12.2142 3.58579 12.55 4 12.55H5.33333C5.74755 12.55 6.08333 12.2142 6.08333 11.8C6.08333 11.3858 5.74755 11.05 5.33333 11.05H4ZM18.6667 11.05C18.2525 11.05 17.9167 11.3858 17.9167 11.8C17.9167 12.2142 18.2525 12.55 18.6667 12.55L20 12.55C20.4142 12.55 20.75 12.2142 20.75 11.8C20.75 11.3858 20.4142 11.05 20 11.05L18.6667 11.05ZM8.07936 16.6704C8.37599 16.3813 8.38209 15.9065 8.09298 15.6099C7.80387 15.3132 7.32903 15.3071 7.0324 15.5962L6.14319 16.4629C5.84656 16.752 5.84046 17.2268 6.12957 17.5235C6.41868 17.8201 6.89351 17.8262 7.19014 17.5371L8.07936 16.6704ZM16.968 15.5963C16.6714 15.3072 16.1966 15.3132 15.9074 15.6098C15.6183 15.9063 15.6243 16.3812 15.9209 16.6703L16.8098 17.537C17.1063 17.8262 17.5812 17.8202 17.8703 17.5236C18.1595 17.227 18.1535 16.7522 17.8569 16.463L16.968 15.5963ZM10 12.5556C10 15.8148 14 15.8148 14 12.5556C14 11.1148 13.0349 9.96 12.4455 9.38909C12.3241 9.27151 12.2634 9.21271 12.1514 9.17711C12.07 9.15122 11.9299 9.15122 11.8485 9.17712C11.7365 9.21272 11.6758 9.27152 11.5544 9.38911C10.965 9.96002 10 11.1148 10 12.5556Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
